export const incidentsRouteEntries = {
  incidents: () => import('./presentation/incidents/IncidentsPage'),
  shiftManagementTab: () => import('./presentation/shiftTickets/ShiftManagementTab'),
} as const;